// extracted by mini-css-extract-plugin
export default {"recomendacoes":"Recomendacoes_recomendacoes__ip05n","titulo":"Recomendacoes_titulo__5HMXp","posts":"Recomendacoes_posts__21waJ"};